window.GA4 = window.GA4 || {};
window.GA4.analyticsGa4 = window.GA4.analyticsGa4 || {};

(function (analytics) {
  let core = {
    nullValue: undefined,

    sendData: function (data) {
      if (this.checkDisableGA()) return;

      window.dataLayer && window.dataLayer.push(data);
    },

    checkDuplicate: function (data) {
      return window.dataLayer && window.dataLayer.findIndex((e) => JSON.stringify(e) === JSON.stringify(data)) != -1;
    },

    getBaseObject: function () {
      const meta = this.getMetaContent();

      if (!meta) return {};

      const data = {
        section_page: meta.section_page,
        category_page: meta.category_page,
        sub_category_page: meta.sub_category_page,
        product_page: meta.product_page,
        market: meta.market,
        language: meta.language,
        campaign_id: meta.campaign_id,
        page_id: meta.page_id,
        portal: meta.portal,
        sub_portal: meta.sub_portal,
        page_title: meta.page_title,
        user_market: meta.user_market,
      };

      return data;
    },

    checkDisableEshopTracking: function () {
      const meta = this.getMetaContent();

      if (!meta) return false;

      return meta.disabled_GA || meta.disable_eshop_tracking;
    },

    checkDisableGA: function () {
      const meta = this.getMetaContent();

      if (!meta) return false;

      return meta.disabled_GA;
    },

    getMetaContent: function () {
      return typeof metaData !== 'undefined' ? metaData : this.nullValue;
    },
  };

  analytics.core = core;
})(window.GA4.analyticsGa4);
